var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _excluded = ["value", "minimumValue", "maximumValue", "step", "minimumTrackTintColor", "maximumTrackTintColor", "thumbTintColor", "thumbStyle", "style", "inverted", "disabled", "trackHeight", "thumbSize", "thumbImage", "onRNCSliderSlidingStart", "onRNCSliderSlidingComplete", "onRNCSliderValueChange"];
var _this = this,
  _jsxFileName = "C:\\Dev\\Projects\\react-native-slider\\package\\src\\RNCSliderNativeComponent.web.tsx";
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var valueToEvent = function valueToEvent(value) {
  return {
    nativeEvent: {
      value: value
    }
  };
};
var RCTSliderWebComponent = _react.default.forwardRef(function (_ref, forwardedRef) {
  var initialValue = _ref.value,
    _ref$minimumValue = _ref.minimumValue,
    minimumValue = _ref$minimumValue === void 0 ? 0 : _ref$minimumValue,
    _ref$maximumValue = _ref.maximumValue,
    maximumValue = _ref$maximumValue === void 0 ? 0 : _ref$maximumValue,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    _ref$minimumTrackTint = _ref.minimumTrackTintColor,
    minimumTrackTintColor = _ref$minimumTrackTint === void 0 ? '#009688' : _ref$minimumTrackTint,
    _ref$maximumTrackTint = _ref.maximumTrackTintColor,
    maximumTrackTintColor = _ref$maximumTrackTint === void 0 ? '#939393' : _ref$maximumTrackTint,
    _ref$thumbTintColor = _ref.thumbTintColor,
    thumbTintColor = _ref$thumbTintColor === void 0 ? '#009688' : _ref$thumbTintColor,
    _ref$thumbStyle = _ref.thumbStyle,
    thumbStyle = _ref$thumbStyle === void 0 ? {} : _ref$thumbStyle,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$inverted = _ref.inverted,
    inverted = _ref$inverted === void 0 ? false : _ref$inverted,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$trackHeight = _ref.trackHeight,
    trackHeight = _ref$trackHeight === void 0 ? 4 : _ref$trackHeight,
    _ref$thumbSize = _ref.thumbSize,
    thumbSize = _ref$thumbSize === void 0 ? 20 : _ref$thumbSize,
    thumbImage = _ref.thumbImage,
    _ref$onRNCSliderSlidi = _ref.onRNCSliderSlidingStart,
    onRNCSliderSlidingStart = _ref$onRNCSliderSlidi === void 0 ? function (_) {} : _ref$onRNCSliderSlidi,
    _ref$onRNCSliderSlidi2 = _ref.onRNCSliderSlidingComplete,
    onRNCSliderSlidingComplete = _ref$onRNCSliderSlidi2 === void 0 ? function (_) {} : _ref$onRNCSliderSlidi2,
    _ref$onRNCSliderValue = _ref.onRNCSliderValueChange,
    onRNCSliderValueChange = _ref$onRNCSliderValue === void 0 ? function (_) {} : _ref$onRNCSliderValue,
    others = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var containerSize = _react.default.useRef({
    width: 0,
    height: 0
  });
  var containerPositionX = _react.default.useRef(0);
  var containerRef = forwardedRef || _react.default.createRef();
  var containerPositionInvalidated = _react.default.useRef(false);
  var _React$useState = _react.default.useState(initialValue || minimumValue),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var lastInitialValue = _react.default.useRef();
  var animationValues = _react.default.useRef({
    val: new _reactNative.Animated.Value(value),
    min: new _reactNative.Animated.Value(minimumValue),
    max: new _reactNative.Animated.Value(maximumValue),
    diff: new _reactNative.Animated.Value(maximumValue - minimumValue || 1)
  }).current;
  _react.default.useEffect(function () {
    animationValues.min.setValue(minimumValue);
    animationValues.max.setValue(maximumValue);
    animationValues.diff.setValue(maximumValue - minimumValue || 1);
  }, [animationValues, minimumValue, maximumValue]);
  var minPercent = _react.default.useRef(_reactNative.Animated.multiply(new _reactNative.Animated.Value(100), _reactNative.Animated.divide(_reactNative.Animated.subtract(animationValues.val, animationValues.min), animationValues.diff))).current;
  var maxPercent = _react.default.useRef(_reactNative.Animated.subtract(new _reactNative.Animated.Value(100), minPercent)).current;
  var onValueChange = (0, _react.useCallback)(function (value) {
    onRNCSliderValueChange && onRNCSliderValueChange(valueToEvent(value));
  }, [onRNCSliderValueChange]);
  var onSlidingStart = (0, _react.useCallback)(function (value) {
    onRNCSliderSlidingStart && onRNCSliderSlidingStart(valueToEvent(value));
  }, [onRNCSliderSlidingStart]);
  var onSlidingComplete = (0, _react.useCallback)(function (value) {
    onRNCSliderSlidingComplete && onRNCSliderSlidingComplete(valueToEvent(value));
  }, [onRNCSliderSlidingComplete]);
  var _updateValue = (0, _react.useCallback)(function (newValue) {
    var hardRounded = decimalPrecision.current < 20 ? Number.parseFloat(newValue.toFixed(decimalPrecision.current)) : newValue;
    var withinBounds = Math.max(minimumValue, Math.min(hardRounded, maximumValue));
    if (value !== withinBounds) {
      setValue(withinBounds);
      onValueChange(withinBounds);
      return withinBounds;
    }
    return hardRounded;
  }, [minimumValue, maximumValue, value, onValueChange]);
  _react.default.useLayoutEffect(function () {
    if (initialValue !== lastInitialValue.current) {
      lastInitialValue.current = initialValue;
      var newValue = _updateValue(initialValue);
      animationValues.val.setValue(newValue);
    }
  }, [initialValue, _updateValue, animationValues]);
  _react.default.useEffect(function () {
    var invalidateContainerPosition = function invalidateContainerPosition() {
      containerPositionInvalidated.current = true;
    };
    var onDocumentScroll = function onDocumentScroll(e) {
      var isAlreadyInvalidated = !containerPositionInvalidated.current;
      if (isAlreadyInvalidated && containerRef.current && e.target.contains(containerRef.current)) {
        invalidateContainerPosition();
      }
    };
    window.addEventListener('resize', invalidateContainerPosition);
    document.addEventListener('scroll', onDocumentScroll, {
      capture: true
    });
    return function () {
      window.removeEventListener('resize', invalidateContainerPosition);
      document.removeEventListener('scroll', onDocumentScroll, {
        capture: true
      });
    };
  }, [containerRef]);
  var containerStyle = _reactNative.StyleSheet.compose({
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
    flexDirection: 'row',
    alignItems: 'center'
  }, style);
  var trackStyle = {
    height: trackHeight,
    borderRadius: trackHeight / 2,
    userSelect: 'none'
  };
  var minimumTrackStyle = Object.assign({}, trackStyle, {
    backgroundColor: minimumTrackTintColor,
    flexGrow: minPercent
  });
  var maximumTrackStyle = Object.assign({}, trackStyle, {
    backgroundColor: maximumTrackTintColor,
    flexGrow: maxPercent
  });
  var thumbViewStyle = _reactNative.StyleSheet.compose({
    width: thumbSize,
    height: thumbSize,
    backgroundColor: thumbTintColor,
    zIndex: 1,
    borderRadius: thumbSize / 2,
    overflow: 'hidden'
  }, thumbStyle);
  var decimalPrecision = _react.default.useRef(calculatePrecision(minimumValue, maximumValue, step));
  _react.default.useEffect(function () {
    decimalPrecision.current = calculatePrecision(minimumValue, maximumValue, step);
  }, [maximumValue, minimumValue, step]);
  var updateContainerPositionX = function updateContainerPositionX() {
    var _ReactDOM$findDOMNode;
    var positionX = (_ReactDOM$findDOMNode = _reactDom.default.findDOMNode(containerRef.current).getBoundingClientRect()) == null ? void 0 : _ReactDOM$findDOMNode.x;
    containerPositionX.current = positionX != null ? positionX : 0;
  };
  var getValueFromNativeEvent = function getValueFromNativeEvent(pageX) {
    var _containerSize$curren = containerSize.current.width,
      width = _containerSize$curren === void 0 ? 1 : _containerSize$curren;
    if (containerPositionInvalidated.current) {
      containerPositionInvalidated.current = false;
      updateContainerPositionX();
    }
    var containerX = containerPositionX.current;
    if (pageX < containerX) {
      return inverted ? maximumValue : minimumValue;
    } else if (pageX > containerX + width) {
      return inverted ? minimumValue : maximumValue;
    } else {
      var x = pageX - containerX;
      var newValue = inverted ? maximumValue - (maximumValue - minimumValue) * x / width : minimumValue + (maximumValue - minimumValue) * x / width;
      return step ? Math.round(newValue / step) * step : newValue;
    }
  };
  var onTouchEnd = function onTouchEnd(_ref2) {
    var nativeEvent = _ref2.nativeEvent;
    var newValue = _updateValue(getValueFromNativeEvent(nativeEvent.pageX));
    animationValues.val.setValue(newValue);
    onSlidingComplete(newValue);
  };
  var onMove = function onMove(_ref3) {
    var nativeEvent = _ref3.nativeEvent;
    var newValue = getValueFromNativeEvent(nativeEvent.pageX);
    animationValues.val.setValue(newValue);
    _updateValue(newValue);
  };
  var accessibilityActions = function accessibilityActions(event) {
    var tenth = (maximumValue - minimumValue) / 10;
    switch (event.nativeEvent.actionName) {
      case 'increment':
        _updateValue(value + (step || tenth));
        break;
      case 'decrement':
        _updateValue(value - (step || tenth));
        break;
    }
  };
  _react.default.useImperativeHandle(forwardedRef, function () {
    return {
      updateValue: function updateValue(val) {
        _updateValue(val);
      }
    };
  }, [_updateValue]);
  return _react.default.createElement(_reactNative.View, (0, _extends2.default)({
    ref: containerRef,
    onLayout: function onLayout(_ref4) {
      var layout = _ref4.nativeEvent.layout;
      containerSize.current.height = layout.height;
      containerSize.current.width = layout.width;
      if (containerRef.current) {
        updateContainerPositionX();
      }
    },
    accessibilityActions: [{
      name: 'increment',
      label: 'increment'
    }, {
      name: 'decrement',
      label: 'decrement'
    }],
    onAccessibilityAction: accessibilityActions,
    accessible: true,
    accessibilityRole: 'adjustable',
    style: containerStyle
  }, others, {
    onStartShouldSetResponder: function onStartShouldSetResponder() {
      return !disabled;
    },
    onMoveShouldSetResponder: function onMoveShouldSetResponder() {
      return !disabled;
    },
    onResponderGrant: function onResponderGrant() {
      return onSlidingStart(value);
    },
    onResponderRelease: onTouchEnd,
    onResponderMove: onMove,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 318,
      columnNumber: 7
    }
  }), _react.default.createElement(_reactNative.Animated.View, {
    pointerEvents: "none",
    style: minimumTrackStyle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 343,
      columnNumber: 9
    }
  }), _react.default.createElement(_reactNative.View, {
    pointerEvents: "none",
    style: thumbViewStyle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 344,
      columnNumber: 9
    }
  }, thumbImage !== undefined ? _react.default.createElement(_reactNative.Image, {
    source: thumbImage,
    style: {
      width: '100%',
      height: '100%'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 346,
      columnNumber: 13
    }
  }) : null), _react.default.createElement(_reactNative.Animated.View, {
    pointerEvents: "none",
    style: maximumTrackStyle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 352,
      columnNumber: 9
    }
  }));
});
function calculatePrecision(minimumValue, maximumValue, step) {
  if (!step) {
    return Infinity;
  } else {
    var decimals = [minimumValue, maximumValue, step].map(function (value) {
      return ((value + '').split('.').pop() || '').length;
    });
    return Math.max.apply(Math, (0, _toConsumableArray2.default)(decimals));
  }
}
RCTSliderWebComponent.displayName = 'RTCSliderWebComponent';
var _default = RCTSliderWebComponent;
exports.default = _default;